import styled, { keyframes } from 'styled-components'

export const Overlay = styled.div`
  position: fixed;
  display: block;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 11;
  cursor: pointer;
`

interface ContainerProps {
  width: string
}

const openTab = (width: string) => keyframes`
 from { width: 0; }
 to { width: ${width}; }
`

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  position: absolute;
  background-color: #f5f5f5;
  top: 0;
  right: 0;
  height: 100%;
  min-width: 30%;
  width: ${(props) => props.width};
  align-items: center;
  padding: 2rem 1rem;
  z-index: 15;
  gap: 1rem;

  overflow-y: scroll;
  overflow-x: hidden;
  animation-name: ${(props) => openTab(props.width)};
  animation-duration: 1.5s;
  ::-webkit-scrollbar {
    display: none;
    width: 10px;
  }
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
  ::-webkit-scrollbar-track {
    border-bottom-right-radius: 8px;
  }

  ::-webkit-scrollbar-thumb {
    background: #4a4a4a;
    border-radius: 8px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`

const appearBox = keyframes`
 from { opacity: 0; }
 to { opacity: 1; }
`

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #fff;
  padding: 1rem 1rem 2rem;
  z-index: 4;
  gap: 1rem;
  width: 100%;
  border-radius: 0.5rem;
  animation-name: ${appearBox};
  animation-duration: 1.5s;
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  > div {
    display: flex;
    align-items: center;
    gap: 1rem;

    > p {
      font-size: 1rem;
    }
  }

  & div > svg {
    color: red;
    background-color: #ffeee7;
    border-radius: 4px;
    padding: 0.1rem;
    cursor: pointer;
  }
`

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export const InfoContainer = styled.div`
  position: relative;
`

interface InfoIconProps {
  hasInfo?: boolean
}

export const InfoIcon = styled.img<InfoIconProps>`
  display: ${(props) => (props.hasInfo ? 'block' : 'none')};
  cursor: pointer;
`

export const Icon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f7f7f7;
  box-shadow: none;
  border: none;
`

interface StageTextProps {
  hasStageInfo?: boolean
}

export const StageText = styled.p<StageTextProps>`
  display: ${(props) => (props.hasStageInfo ? 'block' : 'none')};
  font-size: 0.5rem;
  font-weight: bold;
`

export const ButtonRow = styled.div`
  display: flex;
  justify-content: end;
  align-self: flex-end;
  gap: 1rem;
  padding: 0 3rem;
  width: 40%;
  animation-name: ${appearBox};
  animation-duration: 8s;
`
